module.exports = __webpack_public_path__ + "static/media/3.a68c4315.jpg";